import { Tooltip } from "antd";
import Title from "antd/es/typography/Title";
import PlusIcon from "components/Icons/PlusIcon";
import SecureFaxIcon from "components/Icons/SecureFaxIcon";
import Sibarstyle from "components/layouts/NewSidebar/NewSidebar.style";
import SelectNumber from "components/layouts/SelectNumber";
import { Button } from "components/ui-component";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import {
  useTab,
  setTab,
  setSidebar,
} from "redux/slice/commanSlice";

const NewSidebar = () => {
  const dispatch = useAppDispatch();
  const activeTab = useTab();
  const navigate = useNavigate()

  return (
    <Sibarstyle>
      <div className="sider-subsidebar fax-sidebar active">
        <ul>
          <li className="fax-title-wrapper">
            <Title level={5}>
              <SecureFaxIcon />
              Faxes
            </Title>
            <Tooltip title="Compose a fax">
              <Button
                type="text"
                onClick={() => navigate("/fax/compose-fax")}
                icon={<PlusIcon />}
              />
            </Tooltip>
          </li>
          <li>
            <Button
              type="link"
              size="small"
              onClick={() => {
                dispatch(setTab("inbox"));
                dispatch(setSidebar(false));
              }}
              className={activeTab === "inbox" ? "active" : ""}
            >
              Inbox
            </Button>
          </li>
          <li>
            <Button
              type="link"
              size="small"
              onClick={() => {
                dispatch(setTab("fax"));
                dispatch(setSidebar(false));
              }}
              className={activeTab === "fax" ? "active" : ""}
            >
              Sent Faxes
            </Button>
          </li>
          <li>
            <Button
              type="link"
              size="small"
              onClick={() => {
                dispatch(setTab("contacts"));
                dispatch(setSidebar(false));
              }}
              className={activeTab === "contacts" ? "active" : ""}
            >
              Contacts
            </Button>
          </li>
          <li>
            <Button
              type="link"
              size="small"
              onClick={() => {
                dispatch(setTab("cover-page"));
                dispatch(setSidebar(false));
              }}
              className={activeTab === "cover-page" ? "active" : ""}
            >
              Cover Page
            </Button>
          </li>
        </ul>
        <div className="bottom-section">
          <SelectNumber />
        </div>
      </div>
    </Sibarstyle>
  );
};

export default NewSidebar;
